import { Flex, Icon, Tooltip } from '@aloft/toolkit-sui';

import { Typography } from '../../../../summary/components/Typography.tsx';

export const DepreciateSeparatelyModalContentHeading = ({
  title,
  informationIconText,
}: {
  title: string;
  informationIconText?: string;
}) => {
  return (
    <Flex backgroundColor="surface4" padding=".25rem" gap=".25rem">
      <Typography variant="h3">{title}</Typography>
      {informationIconText && (
        <Tooltip label={informationIconText}>
          <Icon size="sm" icon="information" />
        </Tooltip>
      )}
    </Flex>
  );
};
